import { useFieldArray } from 'react-hook-form';
import { Button, Heading, Paragraph, Textfield } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useSolcelleFormContext } from '../../utils';
import { PanelTypeRadio } from '../panelTypeRadio';
import { InfoPopover } from '../infoPopover';
import { PanelCard, PanelRowWrapper, PanelWrapper, RemoveButtonWrapper } from '../styledComponents';
import { useSolcellerValidation } from '../useSolcellerValidation';
import { RemoveButton } from '../removeButton';

import { SolcelletaksteinInput } from './solcelletaksteinInput';

export const SqmPanels = () => {
  const { t } = useTranslation();
  const { validateAzimuth, validateTilt, integerPattern } = useSolcellerValidation();
  const { control, register, formState, watch } = useSolcelleFormContext();
  const { fields, append, remove } = useFieldArray({ name: 'sqmPanels', control });
  const { errors } = formState;

  const sqmPanels = watch('sqmPanels');
  const hasSolcelletakstein = (index: number) => sqmPanels?.[index]?.panelType === 'solcelletakstein';

  return (
    <PanelWrapper>
      <div>
        <Heading data-size="xs" level={3}>
          {t('register.solar.form.typeAndPlacement.label')}
        </Heading>
        <Paragraph>{t('register.solar.form.typeAndPlacement.info')}</Paragraph>
      </div>
      <InfoPopover />
      {fields.map((field, index) => (
        <PanelCard key={field.id}>
          <PanelTypeRadio fieldPath={`sqmPanels.${index}.panelType`} error={errors.sqmPanels?.[index]?.panelType} />
          <PanelRowWrapper>
            <Textfield
              type="text"
              style={{ flex: 1 }}
              inputMode="numeric"
              label={t('register.solar.form.panel.azimuth')}
              suffix={t('register.solar.form.suffix.grader')}
              error={errors.sqmPanels?.[index]?.azimuth?.message}
              {...register(`sqmPanels.${index}.azimuth`, {
                validate: validateAzimuth,
                pattern: integerPattern
              })}
            />
            <Textfield
              type="text"
              style={{ flex: 1 }}
              inputMode="numeric"
              label={t('register.solar.form.panel.tilt')}
              suffix={t('register.solar.form.suffix.grader')}
              error={errors.sqmPanels?.[index]?.tilt?.message}
              {...register(`sqmPanels.${index}.tilt`, {
                validate: validateTilt,
                pattern: integerPattern
              })}
            />
          </PanelRowWrapper>

          {hasSolcelletakstein(index) && <SolcelletaksteinInput index={index} />}
          {
            // Do not show remove button on first item
            index > 0 && (
              <RemoveButtonWrapper>
                <RemoveButton onClick={() => remove(index)} />
              </RemoveButtonWrapper>
            )
          }
        </PanelCard>
      ))}
      <div>
        <Button variant="secondary" onClick={() => append({})}>
          {t('register.solar.form.buttons.add')}
        </Button>
      </div>
    </PanelWrapper>
  );
};
